import { classNames } from "@ember-decorators/component"
import Component from "@ember/component"
import { computed, get } from "@ember/object"
import { inject as service } from "@ember/service"
import findMany from "cc-frontend/helpers/find-many"
import _ from "lodash"

@classNames("user-home__body__schools__school")
export default class UserHomeSchoolNetwork extends Component {
  @service("ember-store")
  store

  @computed("group.attributes.memberships.length")
  get schoolIds() {
    return _.chain(get(this, "group.attributes.memberships"))
      .filter((membership) => membership.type === "group-membership-group")
      .filter((membership) => membership.attributes.usedAs === "school")
      .map((membership) => membership.attributes.groupId)
      .value()
  }

  @findMany("schoolIds", "group")
  schools
}
